module.exports = __webpack_public_path__ + "img/tesla.3340f231.png";